import { render } from "./FormularioTipoPlano.vue?vue&type=template&id=5efa8fbc&scoped=true"
import script from "./FormularioTipoPlano.vue?vue&type=script&lang=js"
export * from "./FormularioTipoPlano.vue?vue&type=script&lang=js"

import "./FormularioTipoPlano.vue?vue&type=style&index=0&id=5efa8fbc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5efa8fbc"]])

export default __exports__